import ReconstructionChallenge from '../index';
import RegistrationContainer from '../RegistrationContainer';
import DetailContainer from '../DetailContainer';

export default {
    path:      '/rekonstrukcni-vyzva',
    component: ReconstructionChallenge,
    children:  [
        {
            path:      'registrace',
            name:      'reconstructionChallenge.registration',
            component: RegistrationContainer,
        },
        {
            path:      ':slug',
            name:      'reconstructionChallenge.detail',
            component: DetailContainer,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/reconstruction-challenge/router/index.js